import React, { useMemo } from 'react';
import { Skeleton } from 'antd';
import AssetLinksTable from '@components/Tables/AssetLinksTable/AssetLinksTable';
import { useTypedSelector } from '@hooks';
import { InfiniteScroll } from '@components/InfiniteScroll/InfiniteScroll';
import LottieComponent from '@components/Lottie';
import { useListAssetReviewsQuery } from '@hooks/queries/assetReview';
import { useWebSocketDebouncedSubscription } from '@hooks/useWebSocketClient';

function CampaignSharedLinksTab() {
  const campaignInfoModal = useTypedSelector(
    ({ modal }) => modal.campaignInfoModal
  );
  const campaignId = campaignInfoModal?.campaign?.id || '';
  const canManageReviews =
    !!campaignInfoModal?.campaign?.permissions?.createReviews;

  const {
    data: assetReviewsData,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    refetch
  } = useListAssetReviewsQuery({
    params: {
      campaignId,
      orderBy: ['createdAt:DESC']
    },
    enabled: !!campaignInfoModal?.visible
  });

  const assetReviews = useMemo(() => {
    return assetReviewsData?.pages.flatMap((page) => page.edges);
  }, [assetReviewsData]);

  useWebSocketDebouncedSubscription(
    (msg) => msg.payload.campaignId,
    () => refetch(),
    1000,
    (msg) => {
      if (msg.payload.campaignId !== campaignId) return false;
      return !msg.causedByMe;
    },
    'asset-review-created',
    'asset-review-updated',
    'asset-review-removed'
  );

  return (
    <>
      <p className="tab_description">
        Manage links that were shared externally.
      </p>
      <div className="links_container">
        {isLoading || !!assetReviews?.length ? (
          <InfiniteScroll
            loading={isFetchingNextPage ? 'more' : false}
            next={fetchNextPage}
            hasMore={hasNextPage ?? false}
            loader={<Skeleton.Input active style={{ height: 84 }} />}
          >
            <AssetLinksTable
              linksData={assetReviews || []}
              loading={isLoading}
              campaignId={campaignId}
              canManageReviews={canManageReviews}
            />
          </InfiniteScroll>
        ) : (
          <div className="empty_links">
            <LottieComponent className="icon" view="addShareLink" />
            <div className="copy">Start sharing media with your team.</div>
          </div>
        )}
      </div>
    </>
  );
}

export default CampaignSharedLinksTab;
